import React from 'react';
import Box from "@mui/material/Box";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import useDialogHandler from "../../../hooks/useDialogHandler";

const DialogWithMenuBurgerMenu = ({appBarItems}) => {
    const {anchorEl, open, handleClick, handleClose, closeAndExecute} = useDialogHandler()

    const renderMenuItem = (appBarItem, idx) => {
        return (
            <MenuItem key={idx} onClick={() => closeAndExecute(appBarItem.onClick)}>
                <ListItemIcon>
                    {appBarItem.icon}
                </ListItemIcon>
                {appBarItem.text ? <ListItemText>{appBarItem.text}</ListItemText> : null}
            </MenuItem>
        )
    }

    return (
        (<Box sx={{
            ml: "1em"
        }}>
            <IconButton
                id='calendar-burger-menu'
                aria-controls={open ? 'calendar-burger-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}>
                <MenuIcon/>
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    }
                }}
            >
                <MenuList>
                    {appBarItems?.length ? appBarItems.map((item, idx) => renderMenuItem(item, idx)) : null}
                </MenuList>
            </Menu>
        </Box>)
    );
}

export default DialogWithMenuBurgerMenu;